<template>
  <div
    class="app-content content"
    :class="[
      { 'show-overlay': $store.state.app.shallShowOverlay },
      $route.meta.contentClass,
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
  >
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <slot name="breadcrumb">
        <app-breadcrumb v-show="!isLoadingRoute" />
      </slot>
      <div class="content-body">
        <transition
          :duration="transitionDuration"
          :name="routerTransition"
          mode="out-in"
        >
          <recad-loading v-if="isLoadingRoute" />
          <slot v-else />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import RecadLoading from '@/components/atoms/utilsVue/loading/RecadLoading.vue';
import useAppConfig from '@core/app-config/useAppConfig';
import { useLoadingStore } from '@/store/pinia/loadingStore';

export default {
  components: { AppBreadcrumb, RecadLoading },
  computed: {
    isLoadingRoute() {
      return useLoadingStore().isLoadingRoute;
    },
  },

  setup() {
    const { routerTransition, contentWidth, skin } = useAppConfig();
    const transitionDuration = { enter: 150, leave: 150 };

    return { routerTransition, contentWidth, skin, transitionDuration };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
